import { userById } from './types';

const listReducerObject = {
  [userById.request]: (state) =>
    state
      .setIn(['list', 'network', 'error'], false)
      .setIn(['list', 'network', 'loading'], true)
      .setIn(['list', 'network', 'success'], false),
  [userById.success]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['list', 'network', 'loading'], false)
        .setIn(['list', 'network', 'error'], false)
        .setIn(['list', 'network', 'success'], true)
        .mergeIn(['list', 'data'], action.response),
    ),
  [userById.failure]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['list', 'network', 'loading'], false)
        .setIn(['list', 'network', 'error'], action.error)
        .setIn(['list', 'network', 'success'], false),
    ),
};

export default listReducerObject;
